/*
 *             TTTTTTTTTTTTTTTTTTTTTTTTT
 *            S                       SS
 *           S                       S S
 *          S                       S  S
 *         S         KEEN          S  S
 *        S         ETHICS        S  S
 *       S         TEAM          S  S
 *      S                       S  S
 *     S                       S  S
 *    S                       S  S
 *   S                       S  S
 *  STTTTTTTTTTTTTTTTTTTTTTTS  S
 *  S           T           S S
 *  STTTTTTTTTTT TTTTTTTTTTTSS
 *
 */

import React from 'react';
import { Provider } from 'react-redux';
import { StaticBackend } from 'flag';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import sentryConfig from '../../sentry.config';

import { FlagBackendProvider, releaseFlags } from './helpers/featuresFlags/featuresFlags';
import configureStore from './new-design/redux/store/configureStore';
import App from './App';
import './styles/index.scss';

Sentry.init(sentryConfig.client);

const initialState = {};
const store = configureStore(initialState);

const backend = new StaticBackend(releaseFlags);

const container = document.getElementById('react-root');
const root = createRoot(container);

root.render(
  <FlagBackendProvider backend={backend}>
    <Provider store={store}>
      <App />
    </Provider>
  </FlagBackendProvider>,
);
